module.exports = __webpack_public_path__ + "static/media/iconmonstr-user-1.bf2df023.svg";